
import React from "react";
import Navbar from "../navbar/navbar";
import Header from "../header/header";
import AboutMe from "../aboutme/aboutme";
import GridContent from "../gridcontent/gridcontent";
function Portfolio() {

    return (

        <div>
            <Navbar />
            <Header/>
            <AboutMe/>
            <GridContent/>
        </div>
    )
}
export default Portfolio;